import { render, staticRenderFns } from "./PINInput.vue?vue&type=template&id=6145be8c&scoped=true&"
import script from "./PINInput.vue?vue&type=script&lang=js&"
export * from "./PINInput.vue?vue&type=script&lang=js&"
import style0 from "./PINInput.vue?vue&type=style&index=0&id=6145be8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6145be8c",
  null
  
)

export default component.exports